import { type SkillPick } from "encamp-shared/src/skills/skillPickContext";
import {
  ScoutPrivateDocumentExtractionStatus,
  ScoutPrivateDocumentIngestionMode,
} from "generated-graphql/graphql";

export type ScoutOptimisticAttachmentPreview = {
  privateDocumentId: string;
  filename: string;
  mediaType: string;
  sizeBytes: number;
  signedDownloadUrl?: string;
  thumbnailSignedUrl?: string;
  pageCount?: number | null;
  filePartUrl?: string;
  ingestionMode?: ScoutPrivateDocumentIngestionMode;
  extractionStatus?: ScoutPrivateDocumentExtractionStatus;
};

export type ScoutAttachment = {
  privateDocumentId: string;
  filename: string;
  title: string;
  mediaType: string;
  sizeBytes: number;
  signedDownloadUrl?: string;
  thumbnailSignedUrl?: string;
  pageCount?: number | null;
  previewUrl?: string;
  ingestionMode?: ScoutPrivateDocumentIngestionMode;
  extractionStatus?: ScoutPrivateDocumentExtractionStatus;
};

export type ScoutSubmitOptions = {
  attachments?: ScoutAttachment[];
  /** Skills picked from the `/` menu for slugs in the message. */
  skillPicks?: SkillPick[];
  attachmentPreviews?: ScoutOptimisticAttachmentPreview[];
  extractionWatchPrivateDocumentIds?: string[];
};

export type ScoutSubmitHandler = (message: string, options?: ScoutSubmitOptions) => Promise<void>;

export function mapScoutAttachmentToPreview(
  attachment: ScoutAttachment
): ScoutOptimisticAttachmentPreview {
  return {
    privateDocumentId: attachment.privateDocumentId,
    filename: attachment.filename,
    mediaType: attachment.mediaType,
    sizeBytes: attachment.sizeBytes,
    signedDownloadUrl: attachment.signedDownloadUrl,
    thumbnailSignedUrl: attachment.thumbnailSignedUrl,
    pageCount: attachment.pageCount,
    ingestionMode: attachment.ingestionMode,
    extractionStatus: attachment.extractionStatus,
    filePartUrl: `encamp-private-document://${attachment.privateDocumentId}`,
  };
}
